module.exports = __webpack_public_path__ + "img/9 filters-06.e457e3e7.png";